import { RadioInputField } from './RadioInputField'
import { withRadioInputField } from './withRadioInputField'

const ConnectedRadioInputField = withRadioInputField(RadioInputField)

export { ConnectedRadioInputField as RadioInputField }
